import { useEffect, useMemo } from 'react'

import { OVTypes } from 'constants/enums'
import { useParams } from 'react-router-dom'
import { getReasonsJustification } from 'store/OVContext/ovSlice'
import { useDispatch, useSelector } from 'store/store'

import { NDSection } from './components/NDSection'
import { OVBindSection } from './components/OVBindSection'
import { TextNFSection } from './components/TextNFSection'
import * as S from './styles'

const TextAndNDTab = () => {
  const dispatch = useDispatch()
  const {
    observation: { StatusNegociacaoDiferenciadaAprovacao: statusND },
    ovSelected: {
      Cabecalho: { CodigoTipoOrdem },
    },
  } = useSelector((state) => state.ov)
  const { ovNumber } = useParams()

  useEffect(() => {
    dispatch(getReasonsJustification())
  }, [ovNumber])

  const isYRBA = useMemo(() => CodigoTipoOrdem === OVTypes.YRBA, [CodigoTipoOrdem])

  return (
    <S.Wrapper>
      <div className="text-nf">
        <TextNFSection />
      </div>
      {statusND && (
        <div className="nd-form">
          <NDSection />
        </div>
      )}
      {isYRBA && (
        <div className="ov-bind">
          <OVBindSection />
        </div>
      )}
    </S.Wrapper>
  )
}

export default TextAndNDTab
